var map = {
	"./404.svg": 3901,
	"./aimyvoice_logo.svg": 917,
	"./arrow.svg": 9651,
	"./favicon.ico": 6949,
	"./fb.svg": 2314,
	"./page-404.svg": 8285,
	"./search.svg": 5784,
	"./ssml/ru/break1.1_Granddad.wav": 8503,
	"./ssml/ru/emphasis1.1_Elena.wav": 8481,
	"./ssml/ru/p1.1_Roman.wav": 5732,
	"./ssml/ru/prosody1.1_Babygirl.wav": 5995,
	"./ssml/ru/s1.1_Babygirl.wav": 7382,
	"./ssml/ru/say-as1.1_Tatiana.wav": 2043,
	"./ssml/ru/style1.1_Andrey.wav": 7575,
	"./ssml/ru/style1.2_Andrey.wav": 161,
	"./ssml/ru/style1.3_Andrey.wav": 125,
	"./ssml/ru/style2.1_Elena.wav": 5217,
	"./ssml/ru/style2.2_Elena.wav": 3737,
	"./ssml/ru/style2.3_Elena.wav": 5918,
	"./ssml/ru/style3.1_Andrey.wav": 3307,
	"./ssml/ru/style3.2_Granddad.wav": 5326,
	"./ssml/ru/style3.3_Elena.wav": 9962,
	"./ssml/ru/style3.4_Regina.wav": 1618,
	"./ssml/ru/style3.5_Roman.wav": 6435,
	"./ssml/ru/style3.6_Grandma.wav": 2860,
	"./ssml/ru/style4.1_Blonde.wav": 8142,
	"./ssml/ru/style4.2_Elena.wav": 3266,
	"./ssml/ru/style4.3_Andrey.wav": 4062,
	"./ssml/ru/style4.4_Elena.wav": 3696,
	"./ssml/ru/style4.5_Andrey.wav": 6618,
	"./ssml/ru/style4.6_Elena.wav": 712,
	"./ssml/ru/sub1.1_Valery.wav": 6491,
	"./v_logo.svg": 6520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7165;